 export default () => ({
    vaccinationCovid: [],
    vaccinationNotCovid: [],
    vaccinationSchemeValues: {},
 })